import { DURATION, EASE_OUT, reducedMotion } from '../../src/js/utils/motion';

const setup = (details: HTMLDetailsElement): void => {
  const summary = details.querySelector<HTMLElement>('summary');
  const body = details.querySelector<HTMLElement>('.faq__answer');

  if (!summary || !body) {
    return;
  }

  let animation: Animation | null = null;

  const run = (from: number, to: number, onDone: () => void) => {
    animation?.cancel();
    body.style.overflow = 'hidden';

    animation = body.animate(
      { height: [`${from}px`, `${to}px`], opacity: [from ? 1 : 0, to ? 1 : 0] },
      { duration: DURATION.base, easing: EASE_OUT }
    );

    animation.onfinish = () => {
      animation = null;
      body.style.overflow = '';
      onDone();
    };
  };

  const expand = () => {
    details.open = true;
    run(0, body.getBoundingClientRect().height, () => undefined);
  };

  const collapse = () => {
    run(body.getBoundingClientRect().height, 0, () => {
      details.open = false;
    });
  };

  const closeSiblings = () => {
    if (!details.name) {
      return;
    }

    document
      .querySelectorAll<HTMLDetailsElement>(`details[name="${details.name}"][open]`)
      .forEach((other) => {
        if (other !== details) {
          other.dispatchEvent(new CustomEvent('gf-faq-collapse'));
        }
      });
  };

  details.addEventListener('gf-faq-collapse', collapse);

  summary.addEventListener('click', (event) => {
    if (reducedMotion()) {
      return;
    }

    event.preventDefault();

    if (details.open) {
      collapse();
      return;
    }

    closeSiblings();
    expand();
  });
};

const init = (): void => {
  document.querySelectorAll<HTMLDetailsElement>('.faq__item').forEach(setup);
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', init, { once: true });
} else {
  init();
}
